import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { InMemoryScrollingOptions, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { register } from 'swiper/element';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routing';
import { CoreModule } from './app/core/core.module';
import { AuthInterceptor } from './app/core/middleware/auth.interceptor';
import { ErrorHandlerService } from './app/core/middleware/error-handler';
import { ModulePreloadService } from './app/core/services/module-preload.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

register();

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, CoreModule),
    provideCharts(withDefaultRegisterables()),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES, withPreloading(ModulePreloadService), withInMemoryScrolling(scrollConfig), withComponentInputBinding()),
  ],
}).catch(err => console.error(err));
